/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.pages.forms.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.factory.gridState',
  'acme.view.application.pos.create.pages.forms.page.controllers',
  'acme.view.application.pos.create.pages.forms.tile.controllers',
  'acme.view.application.pos.create.pages.forms.standard.controllers',
  'acme.view.application.pos.create.pages.forms.generalAdmission.controllers',
  'acme.view.application.pos.create.pages.forms.navigation.controllers',
  'acme.view.application.pos.create.pages.forms.addons.controllers',
  'acme.view.application.pos.create.pages.forms.membership.controllers',
  'acme.view.application.pos.create.pages.forms.donations.controllers'
])

.controller('PosCreatePagesFormsController', ['$scope', '$timeout', 'ApiService', 'HelpersService', 'GridStateFactory', function($scope, $timeout, ApiService, HelpersService, GridStateFactory) {

    $scope.posCreatePagesForms = {

      model: {
        type: false,
        backPaths: ['page'],
        page: {}
      },

      gridState: new GridStateFactory(),

      init: function() {
        $scope.$on('PosCreatePagesController::Select', this.onPosCreatePagesControllerSelect);
        $scope.$on('PosCreatePagesController::SelectTile', this.onPosCreatePagesControllerSelectTile);

        $scope.$on('PosCreatePagesFormsController::Cancel', this.onPosCreatePagesFormsControllerCancel);

        $scope.$on('PosCreatePagesFormsTileController::Select', this.onPosCreatePagesFormsTileControllerSelect);
        $scope.$on('PosCreatePagesFormsTileController::Cancel', this.onPosCreatePagesFormsTileControllerCancel);

        this.getEventTemplates();

      },

      getEventTemplates: function () {

        this.gridState.setPropertyValue('pageSize', 20);

        ApiService.program.list(false, this.gridState.getGridState()).then(this.success.getEventTemplates, this.error.getEventTemplates);
      },

      isType: function(type) {
        return (this.model.type === type);
      },

      setType: function(type) {
        this.model.type = type;
      },

      success: {
        init: function(response) {},
        getEventTemplates: function(response) {
          $scope.$broadcast('PosCreatePagesFormsController::TemplatesUpdate', { list: response.data.payload.list, count: response.data.payload.count });
        }
      },

      error: {
        init: function(response) {},
        getEventTemplates: function(response) {
          $scope.$broadcast('PosCreatePagesFormsController::TemplatesUpdate', { list: [] });
        }
      },

      onPosCreatePagesControllerSelect: function(e, data) {
        var self = $scope.posCreatePagesForms;

        self.backPaths = ['page'];
        self.setType('page');

        if (data) {
          self.model.page = data;
        }

        // next tick
        $timeout(function() {
          $scope.$broadcast('PosCreatePagesFormsController::UpdatePage', self.model.page);
        }, 0);
      },

      onPosCreatePagesControllerSelectTile: function(e, data) {
        var self = $scope.posCreatePagesForms;

        self.backPaths = ['page'];
        self.setType(data.config.type);

        // next tick
        $timeout(function() {
          $scope.$broadcast('PosCreatePagesFormsController::Update', data);
        }, 0);
      },

      onPosCreatePagesFormsControllerCancel: function(e, data) {
        var self = $scope.posCreatePagesForms,
            event = 'PosCreatePagesFormsController::Update',
            form = {
              config: {
                type: self.backPaths.pop()
              }
            };

        self.setType(form.config.type);

        if (form.config.type === 'page') {
          event = 'PosCreatePagesFormsController::UpdatePage';
          form = $.extend(form, self.model.page);
        }else{
          form = data;
        }

        // next tick
        $timeout(function() {
          $scope.$broadcast(event, form);
        }, 0);
      },

      onPosCreatePagesFormsTileControllerSelect: function(e, data) {
        var self = $scope.posCreatePagesForms;

        self.backPaths.push('tile');
        self.setType(data.config.type);

        // next tick
        $timeout(function() {
          $scope.$broadcast('PosCreatePagesFormsController::Update', data);
        }, 0);
      },

      onPosCreatePagesFormsTileControllerCancel: function(e, data) {
        // Remove tile
        $scope.$emit('PosCreatePagesFormsController::RemoveTile', data);
        // Reroute to page form
        $scope.posCreatePagesForms.onPosCreatePagesControllerSelect(e, data);
      }

    };

    $scope.posCreatePagesForms.init();

}]);